/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Fact_Price_LInputs */

const en_wc_fact_price_l = /** @type {(inputs: Wc_Fact_Price_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free forever. No trial, no paid tier.`)
};

/**
* | output |
* | --- |
* | "Free forever. No trial, no paid tier." |
*
* @param {Wc_Fact_Price_LInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_fact_price_l = /** @type {((inputs?: Wc_Fact_Price_LInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Fact_Price_LInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_fact_price_l(inputs)
});
export { wc_fact_price_l as "wc.fact.price_l" }